export default class Config {
    static CARROT_IDENTITY_ID = "57a413a1-0ba0-46f0-97a6-e189d5911d9c";

    static apiOptions = {
        api_target: "fresh",
        //api_key: "G8wsDYNmgYI2bWit4wxM2B93wHk4e9uezMMwJWP9",
        api_key: "WevD74nEndCAITuZnLuVGXEnkLP6EdP9nw1Z0efI",
        api_root: "https://fresh.meetcarrot.xyz/api",
        static_root: "https://fresh.meetcarrot.xyz/static",
        auth_uri: "https://fresh.meetcarrot.xyz/oauth2/token/"
    }
}



// WEBPACK FOOTER //
// ./src/constants/config.js